import Image from 'next/image';
import { Fragment, Suspense } from 'react';

import { BodyContentType } from '@/features/pages/types';

import { Carousel } from '../carousel/Carousel.component';
import { TextBlock } from '../text-block/TextBlock.component';
import { Video } from '../video/Video.component';

import styles from './PodContent.module.scss';

export const PodContent = ({ content }: { content: BodyContentType[] | BodyContentType }) => {
    return (Array.isArray(content) ? content : [content]).map(
        (pod: BodyContentType, index: number) => {
            switch (pod.type) {
                case 'text':
                    return <TextBlock key={`text-${pod.id}`} content={pod.text} resetText />;
                case 'gallery':
                    return (
                        <Carousel
                            key={`gallery-${pod.id}`}
                            containerClass={styles.carousel}
                            slideClass={styles.slide}
                            align={'start'}
                            thumbnails={pod.images.map((media: any) => (
                                <Image
                                    key={media.id}
                                    className={styles.thumbnail}
                                    alt={media.description}
                                    height={media.image.height}
                                    src={media.image.src}
                                    width={media.image.width}
                                />
                            ))}
                        >
                            {pod.images.map((media: any) => (
                                <Image
                                    key={media.id}
                                    alt={media.description}
                                    height={media.image.height}
                                    src={media.image.src}
                                    width={media.image.width}
                                />
                            ))}
                        </Carousel>
                    );
                case 'trailer':
                    return (
                        <Suspense
                            key={`video-${pod.id}`}
                            fallback={
                                <p>
                                    <a href="pod.url">pod.url</a>
                                </p>
                            }
                        >
                            <Video url={pod.url} />
                        </Suspense>
                    );
                default:
                    return <Fragment key={`null-${index}`}></Fragment>;
            }
        }
    );
};
